import { Container, Row, Col, Table } from 'react-bootstrap';
import React, { Component } from 'react';
import Card from '../../components/Card/Card.jsx';
// eslint-disable-next-line
import Chart from 'chart.js/auto';
import { Link } from 'react-router-dom';
import { Line } from 'react-chartjs-2';
import axios from 'axios';
import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

class adminGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: '',
      aData: '',
      iq: '',
      comment: '',
      graph1String: '',
      graph2String: '',
      graph3String: '',
    };
    this.insertComment = this.insertComment.bind(this);
    this.onChange = this.onChange.bind(this);
    this.cc = this.cc.bind(this);
    this.getCanvasBase64 = this.getCanvasBase64.bind(this);
    this.buttonThing = this.buttonThing.bind(this);
    this.downloadFileObject = this.downloadFileObject.bind(this);
  }
  onChange(e) {
    console.log(e.target.name, e.target.value)
    this.setState({ [e.target.name]: e.target.value })
  }

  downloadFileObject(base64String, fileName) {
    const linkSource = base64String;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName + ' rezultati.pdf';
    downloadLink.click();
  }

  async downloadPDF() {
    const b64s = {
      s1: this.getCanvasBase64('myChart'),
      s2: this.getCanvasBase64('myChart1'),
      s3: this.getCanvasBase64('myChart2')
    }

    const graphExplanations = {
      g1: this.state.data?.[`upis`]?.[0],
      g2: this.state.data?.[`upis`]?.[1],
      g3: this.state.data?.[`upis`]?.[2]
    }
    await axios.post(`/api/adminApi/downloadApplicationLetter/`, { 'internId': this.props.match.params._id, 'int': this.state.iq, 'comment': this.state.comment, 'graphs': b64s, 'explanation': graphExplanations }, { headers: { responseType: 'blob' } })
      .then(data => {
        let base64String = data.data
        base64String = "data:application/pdf;base64," + base64String;
        this.downloadFileObject(base64String, this.state.data?.internName);
      })
      .catch(err => {
        console.log(err)
        console.log('Fuck')
      })
  }
  insertComment() {
    Swal.fire({
      title: 'Unos komentara',
      text: "Unesite komentar",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Unesi'
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          const { value: reason } = await Swal.fire({
            input: 'textarea',
            inputLabel: 'Komentar',
            inputPlaceholder: 'Komentar...',
            inputAttributes: {
              'aria-label': 'Unesite Komentar'
            },
            showCancelButton: true
          })
          if (reason) {
            axios.post(`/api/users/insertComment/`, { _id: this.props.match.params._id, comment: reason })
              .then(response => {
                console.log(response)
                Swal.fire({
                  position: 'top-end',
                  icon: 'success',
                  title: 'Komentar unet',
                  showConfirmButton: false,
                  timer: 1500
                })
              })
              .catch(err => {
                console.log(err)
                Swal.fire({
                  position: 'top-end',
                  icon: 'error',
                  title: 'Problem prilikom izvršavanja',
                  showConfirmButton: false,
                  timer: 1500
                })
              })
          }
        }
      })
  }

  async componentDidMount() {
    if (this.props.match.params._id) {
      // get users int results
      await axios.post(`/api/intApi/convertResults`, { 'internId': this.props.match.params._id })
        .then(response => {
          console.log(response.data)
          this.setState({ iq: response.data })
        })
        .catch(err => {
          console.log(err)
        })
      // get users personality data
      await axios.post(`/api/adminGraph/thing/`, { 'id': this.props.match.params._id })
        .then(response => {
          console.log(response.data)
          this.setState({ data: response.data })
          this.setState({ comment: response.data.comment })
        })
        .catch(err => {
          console.log(err)
        })

      // get users admissionApplication 
      await axios.post(`/api/adminApi/retriveApplicationData`, { 'internId': this.props.match.params._id })
        .then(response => {
          this.setState({ aData: response.data })
        })
        .catch(err => {
          console.log(err)
        })
    }

    this.cc(this.state.data.graph1, 'myChart')
    this.cc(this.state.data.graph2, 'myChart1')
    this.cc(this.state.data.graph3, 'myChart2')

    //await this.buttonThing();
  }

  downloadInternDV() {
    const downloadFileObject = (base64String) => {
      const linkSource = base64String;
      const downloadLink = document.createElement("a");
      const fileName = this.state.aData?.firstAndLastName + " CV.pdf";
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }
    const downloadAsPdf = () => {
      console.log(this.state.aData)
      let base64String = this.state.aData?.file;
      if (base64String.startsWith("JVB")) {
        base64String = "data:application/pdf;base64," + base64String;
        downloadFileObject(base64String);
      } else if (base64String.startsWith("data:application/pdf;base64")) {
        downloadFileObject(base64String);
      } else {
        alert("Greska");
      }
    }
    downloadAsPdf();
  }

  buttonThing() {
    this.setState({ graph1String: this.getCanvasBase64('myChart') })
    this.setState({ graph2String: this.getCanvasBase64('myChart1') })
    this.setState({ graph3String: this.getCanvasBase64('myChart2') })
  }

  cc(data, chartId) {
    const ctx = document.getElementById(chartId).getContext('2d');
    const myChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: ['D', 'I', 'S', 'C'],
        datasets: [
          {
            label: 'Data',
            data: data,
            backgroundColor: 'rgba(51, 153, 255,1)',
            borderColor: 'rgba(173, 216, 230)',
            borderWidth: 2
          },
          {
            label: 'Siva zona',
            data: Array(4).fill(4),
            borderColor: 'rgba(176, 169, 173, 0.8)',
            borderWidth: 2,
            borderDash: [10, 5]
          }
        ]
      },
      options: {
        scales: {
          y: {
            min: 0,
            max: 7,
            beginAtZero: true
          }
        }
      }
    });

  }


  // Convert canvas to Base64
  getCanvasBase64(chartId) {
    const canvas = document.getElementById(chartId);
    console.log(canvas.toDataURL('image/png'));
    return canvas.toDataURL('image/png');
  }

  render() {
    const checkOne = this.state.data?.[`checkValues`]?.[0] === 28 ? ({ backgroundColor: 'white' }) : ({ backgroundColor: 'red' });
    const checkTwo = this.state.data?.[`checkValues`]?.[1] === 28 ? ({ backgroundColor: 'white' }) : ({ backgroundColor: 'red' });


    let cvButton = this.state.aData != '' ?
      <button className="btn btn-primary btn-fill" type="submit" onClick={this.downloadInternDV.bind(this)}>Preuzmi CV</button>
      :
      <button className="btn btn-primary btn-fill" type="submit" onClick={this.downloadInternDV.bind(this)} disabled>Preuzmi CV</button>
    return (
      <Container fluid >

        <Row className='justify-content-center'>
          <Col sm={3}>
            <Card
              title="IQ vrednost"
              content={
                <Row className='justify-content-center'>
                  <Col md={2}>
                    <button disabled className="btn btn-primary btn-fill" >{this.state.iq}</button>
                  </Col>
                </Row>
              }
            />
          </Col>
          <Col md={9}>
            <Card
              content={
                <Row>
                  <Col md={2}>
                    <input
                      type='button'
                      className='btn btn-info btn-fill'
                      onClick={this.insertComment}
                      value='Komentar'
                    />
                  </Col>
                  <Col md={10}>
                    <div className="col-md-12">
                      <textarea
                        class="form-control"
                        label="Opis grafikona"
                        placeholder="Opis grafikona"
                        name="comment"
                        value={this.state.data?.comment}
                      />
                    </div>
                  </Col>
                </Row>
              }
            />
          </Col>


        </Row>
        <Row>
          <Col sm={4}>
            <Card
              content={
                <Row className='justify-content-center'>
                  <Col md={6}>
                    <button className="btn btn-primary btn-fill" onClick={this.downloadPDF.bind(this)}>Preuzmi pdf </button>
                  </Col>
                  <Col md={6}>
                    {cvButton}
                  </Col>
                </Row>
              }
            />
          </Col>
        </Row>
        <Row>
          <Col sm={9}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <td colSpan={2}>Ime:
                    <Link
                      to={`/adminPanel/adminGraph/internData/${this.props.match.params._id}`}
                      //className="btn-fill col-md-12 pull-center btn btn-default"
                      style={{ margin: '3px' }}
                    >
                      {this.state.data?.internName}
                    </Link>
                  </td><td colSpan={2}>Mail: {this.state.data?.internEmail}</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Dimenzije</td>
                  <td>Kako on vidi sebe</td>
                  <td>Kako ga drugi vidi</td>
                  <td>Kakav je zapravo</td>
                </tr>
                <tr>
                  <td>D - Liderstvo</td>
                  <td>{this.state.data?.[`D-liderstvo`]?.[0]}</td>
                  <td>{this.state.data?.[`D-liderstvo`]?.[1]}</td>
                  <td>{this.state.data?.[`D-liderstvo`]?.[2]}</td>
                </tr>
                <tr>
                  <td>I - Komunikacija</td>
                  <td>{this.state.data?.[`I-komunikacija`]?.[0]}</td>
                  <td>{this.state.data?.[`I-komunikacija`]?.[1]}</td>
                  <td>{this.state.data?.[`I-komunikacija`]?.[2]}</td>
                </tr>
                <tr>
                  <td>S - Upravljivost</td>
                  <td>{this.state.data?.[`S-upravljivost`]?.[0]}</td>
                  <td>{this.state.data?.[`S-upravljivost`]?.[1]}</td>
                  <td>{this.state.data?.[`S-upravljivost`]?.[2]}</td>
                </tr>
                <tr>
                  <td>C - Vrednost</td>
                  <td>{this.state.data?.[`C-vrednost`]?.[0]}</td>
                  <td>{this.state.data?.[`C-vrednost`]?.[1]}</td>
                  <td>{this.state.data?.[`C-vrednost`]?.[2]}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>{this.state.data?.[`SumNValues`]?.[0]}</td>
                  <td>{this.state.data?.[`SumNValues`]?.[1]}</td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td style={checkOne}>{this.state.data?.[`checkValues`]?.[0]}</td>
                  <td style={checkTwo}>{this.state.data?.[`checkValues`]?.[1]}</td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td>{this.state.data?.[`printValues`]?.[0]}</td>
                  <td>{this.state.data?.[`printValues`]?.[1]}</td>
                  <td>{this.state.data?.[`printValues`]?.[2]}</td>
                </tr>
                <tr>
                  <td>D</td>
                  <td>{this.state.data?.[`D`]?.[0]}</td>
                  <td>{this.state.data?.[`D`]?.[1]}</td>
                  <td>{this.state.data?.[`D`]?.[2]}</td>
                </tr>
                <tr>
                  <td>I</td>
                  <td>{this.state.data?.[`I`]?.[0]}</td>
                  <td>{this.state.data?.[`I`]?.[1]}</td>
                  <td>{this.state.data?.[`I`]?.[2]}</td>
                </tr>
                <tr>
                  <td>S</td>
                  <td>{this.state.data?.[`S`]?.[0]}</td>
                  <td>{this.state.data?.[`S`]?.[1]}</td>
                  <td>{this.state.data?.[`S`]?.[2]}</td>
                </tr>
                <tr>
                  <td>C</td>
                  <td>{this.state.data?.[`C`]?.[0]}</td>
                  <td>{this.state.data?.[`C`]?.[1]}</td>
                  <td>{this.state.data?.[`C`]?.[2]}</td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row md={12} className='justify-content-center'>
          <Col md={7}>
            <Card
              statsIcon="fa fa-history"
              title="Kako on vidi sebe"
              category={this.state.data?.[`upis`]?.[0]}
              content={
                <canvas id="myChart" />
              }
            />
          </Col>
          <Col md={7}>
            <Card
              statsIcon="fa fa-history"
              title="Kako ga drugi vide"
              category={this.state.data?.[`upis`]?.[1]}
              content={
                <canvas id="myChart1" />
              }
            />
          </Col>
          <Col md={7}>
            <Card
              statsIcon="fa fa-history"
              title="Kakav zaista jeste"
              category={this.state.data?.[`upis`]?.[2]}
              content={
                <canvas id="myChart2" />
              }
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default adminGraph;
